import React, { useState, useEffect, useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import SharedChatView from '../components/SharedChatView';
import { chatStorage, Chat, Message } from '../utils/chatStorage';
import mgLogo from '../assets/mygate_logo.jpg';

export default function ShareApp() {
  const { shareId } = useParams<{ shareId: string }>();
  const navigate = useNavigate();
  const [chats, setChats] = useState<Chat[]>([]);
  const [currentChatId, setCurrentChatId] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);

  useEffect(() => {
    const loadedChats = chatStorage.getAllChats();
    setChats(loadedChats);
    if (loadedChats.length > 0) setCurrentChatId(loadedChats[0].id);
  }, []);

  const handleContinue = useCallback((messages: Message[], module: string | undefined) => {
    const newChat = chatStorage.createChat();
    chatStorage.updateChat(newChat.id, { messages, selectedModule: module });
    navigate('/');
  }, [navigate]);

  if (!shareId) return <Navigate to="/" replace />;

  return (
    <div className={`App ${sidebarOpen ? 'sidebar-is-open' : ''}`}>
      <Sidebar
        chats={chats}
        currentChatId={currentChatId}
        onSelectChat={() => navigate('/')}
        onNewChat={() => navigate('/')}
        onDeleteChat={(chatId) => {
          chatStorage.deleteChat(chatId);
          setChats(prev => prev.filter(c => c.id !== chatId));
        }}
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(o => !o)}
      />
      <div className="app-main">
        <header className="App-header">
          <div className="header-left">
            <button className="header-sidebar-toggle" onClick={() => setSidebarOpen(o => !o)} title="Toggle sidebar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
            <div className="header-brand">
              <div className="header-logo-mark">
                <img src={mgLogo} alt="Mygate" />
              </div>
              <div className="header-divider" />
              <div className="header-brand-text">
                <h1>MIRA <span>One</span></h1>
                <p>Mygate Intelligent Response Assistant</p>
              </div>
            </div>
          </div>
        </header>
        <main>
          <SharedChatView shareId={shareId} onContinueInApp={handleContinue} />
        </main>
      </div>
    </div>
  );
}
